import { useUpdateTimeEntryMutation } from "generated/graphql";
import getLocalString from "constants/Localization";
import useBitumioMutation from "hooks/useBitumioMutation";

export const useUpdateTimeEntry = () => {
  const [mutation, { loading, error, data }] = useUpdateTimeEntryMutation({
    update: (cache) => {
      // Also invalidate skipped views so switching tabs cannot reuse stale results.
      cache.evict({ id: "ROOT_QUERY", fieldName: "getTimeEntries" });
      cache.evict({ id: "ROOT_QUERY", fieldName: "getTimeEntriesGroupedByUser" });
    },
    awaitRefetchQueries: true,
    refetchQueries: ["customGetTimeEntries", "getTimeEntries", "getTimeEntriesGroupedByUser"],
  });

  const [updateTimeEntry, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "updateTimeEntry",
    },
    {
      successMessage: getLocalString("time-tracking.update-time-entry-success"),
      failureMessage: getLocalString("time-tracking.update-time-entry-failure"),
      showValidationErrors: true,
    }
  );

  return [updateTimeEntry, context] as const;
};
